export enum PortalUrls {
  ClientPortal = '/clients',
  DonorPortal = '/donor-portal',
  AdminPortal = '/admin-dashboard'
}
